"use stric";

import api from "./apiService.js";
import WithToken from "./tokenService";
import configuration from "./../../config.json";

const logisticGroupsService = {
  getLogisticGroups: function (options) {
    return api.get("/LogisticGroups", WithToken.headersToken({ params: options }, configuration.cookieName));
  },
  createLogisticGroup: function (options) {
    return api.post(`/LogisticGroups`, options, WithToken.headersToken({}, configuration.cookieName));
  },
  deleteLogisticGroup: function (options) {
    return api.delete(`/LogisticGroups`, WithToken.headersToken({ params: options }, configuration.cookieName));
  },
  createControlPointLogisticGroup: function (options) {
    return api.post(`/ControlPointLogisticGroups`, options, WithToken.headersToken({}, configuration.cookieName));
  },
  deleteCreateControlPointLogisticGroup: function (options) {
    return api.delete(`/ControlPointLogisticGroups`, WithToken.headersToken({ params: options }, configuration.cookieName));
  },
};

export default logisticGroupsService;
